module.exports = __webpack_public_path__ + "img/Monte_Kope_119.bdb9ea2e.jpg";